import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Heading from "../../components/common/Typography/Heading";
import MainButton from "../../components/common/MainButton/MainButton";
import Snippet from "../../components/common/SnippetIcon/Snippet";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const HelpCenterLayout = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={`mx-auto w-full max-w-field-page-md ${publicMainHeaderOffsetClass()}`}>
        <Heading variant={"h1"} className="text-center w-full text-offblack">
          Help Centre
        </Heading>
        <div className={`w-full ${PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS}`}>
          <Snippet
            variant={"label"}
            label={"Search our knowledge base or browse categories below"}
            star={false}
          />
          <div className={`relative w-full ${PUBLIC_HEADING_TO_BODY_CLASS}`}>
              <input
                className="box-border block h-[50px] w-full rounded-[4px] border border-solid border-[#C0C0C0] border-[1.4px] bg-white px-3 font-inter text-offblack input-placeholder placeholder-lightgray placeholder:font-inter focus:border focus:border-primaryblue"
                placeholder="Need assistance? Search your question"
                maxLength={150}
              />
          </div>
        </div>

        <Outlet />
      </div>

      <div className={`bg-white rounded-lg ${PUBLIC_SECTION_GAP_CLASS} w-[350px] h-[200px] sm:w-[400px] sm:h-[200px] xl:w-[616px] xl:h-[200px] mx-auto flex items-center justify-center`}>
        <div>
          <Heading variant={"h6"} className="text-center">
            Do you need additional assistance?
          </Heading>
          <div className="flex justify-center mt-8 lg:mt-10">
            <MainButton
              variant={"medium"}
              onClick={() => navigate("/contactus")}
            >
              Contact Us
            </MainButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpCenterLayout;

